
export interface Purchase {
  name: string
  location: string
  timeAgo: string
}

export const purchases: Purchase[] = [
  { name: 'Emily', location: 'Portland, OR', timeAgo: '2 minutes ago' },
  { name: 'Hannah', location: 'Nashville, TN', timeAgo: '5 minutes ago' },
  { name: 'Sophie', location: 'Denver, CO', timeAgo: '12 minutes ago' },
  { name: 'Grace', location: 'Austin, TX', timeAgo: '15 minutes ago' },
  { name: 'Lucy', location: 'Asheville, NC', timeAgo: '22 minutes ago' },
  { name: 'Claire', location: 'Seattle, WA', timeAgo: '28 minutes ago' },
  { name: 'Danielle', location: 'Charleston, SC', timeAgo: '35 minutes ago' },
  { name: 'Martha', location: 'Madison, WI', timeAgo: '42 minutes ago' },
  { name: 'Josie', location: 'Toronto, Canada', timeAgo: '50 minutes ago' },
  { name: 'Paula', location: 'Brighton, UK', timeAgo: '1 hour ago' },
]
